export default __webpack_public_path__ + "static/media/image-60.ff690810.png";